import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

import ModalWrapper from 'components/Modals/ModalWrapper';
import { UploadPdfForm } from './UploadPdfForm';

class AddFormModal extends Component {
  static propTypes = {
    permissions: PropTypes.arrayOf(PropTypes.string),
    isShown: PropTypes.bool.isRequired,
    imyTier: PropTypes.shape(),
    addImyLayer: PropTypes.bool,
    isAddingForm: PropTypes.bool,
    onConfirmUpload: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    addingFormResults: PropTypes.shape({
      error: PropTypes.shape({
        code: PropTypes.number,
        message: PropTypes.string,
      }),
      success: PropTypes.bool,
      files: PropTypes.arrayOf(PropTypes.shape({}))
    })
  };

  static defaultProps = {
    permissions: null,
    imyTier: null,
    addImyLayer: null,
    isAddingForm: false,
    addingFormResults: null
  };

  constructor() {
    super();
    this.state = { disableConfirmButton: true, modalSize: 'modal-allow-overflow' };
    this.setDisableConfirm = this.setDisableConfirm.bind(this);
    this.disableConfirm = this.disableConfirm.bind(this);
  }

  onCloseModal(e) {
    const { onCancel } = this.props;

    if (onCancel) {
      onCancel(e);
    }
  }

  getParentCustomerName() {
    const { imyTier } = this.props;
    const na = 'N/A';

    if (imyTier?.customerName && imyTier.customerName !== na) {
      return imyTier.customerName;
    }

    return imyTier?.accountName || na;
  }

  setDisableConfirm(val) {
    this.setState({ disableConfirmButton: val });
  }

  setModalSize(val) {
    this.setState({ modalSize: val });
  }

  disableConfirm() {
    if (this.state) {
      const { disableConfirmButton } = this.state;
      return disableConfirmButton;
    }
    return true;
  }

  render() {
    const {
      isShown,
      isAddingForm,
      imyTier,
      addImyLayer,
      onConfirmUpload,
      addingFormResults,
      permissions
    } = this.props;
    const {
      modalSize
    } = this.state;
    return (
      <ModalWrapper
        headerClose={ false }
        isOpen={ isShown }
        title={ imyTier ? `Add/Amend beneficiary form(s) for ${ this.getParentCustomerName() }` : 'Add form(s)' }
        btnConfirmTitle="Submit"
        btnConfirmClass={ `btn-primary ${ isAddingForm ? 'loading' : '' }` }
        btnCancelTitle="Close"
        onCancel={ e => this.onCloseModal(e) }
        disableConfirm={ this.disableConfirm }
        modalSize={ modalSize }
        formId="uploadingPdfForm"
      >
        <UploadPdfForm
          id="uploadingPdfForm"
          onSubmit={ onConfirmUpload }
          onSetModalSize={ val => this.setModalSize(val) }
          permissions={ permissions }
          imyTier={ imyTier }
          addImyLayer={ addImyLayer }
          results={ addingFormResults }
          isSubmitting={ isAddingForm }
          setDisableConfirm={ val => this.setDisableConfirm(val) }
        />
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    auth: {
      permissions
    },
    forms: {
      isAddingForm,
      imyTier,
      addImyLayer,
      addingFormResults
    }
  } = state;
  return {
    imyTier,
    permissions,
    addImyLayer,
    isAddingForm,
    addingFormResults
  };
};

export default connect(
  mapStateToProps
)(AddFormModal);
